import { Entity } from "@jobilla/entity";

export class ContactPerson extends Entity {
  public name!: string;
  public email!: string;
  public phone!: string;
}
